import { formatNumber, formatRupiah } from '@/utils/Formatter'

export default {
  install(app) {
    app.config.globalProperties.$formatNumber = formatNumber
    app.config.globalProperties.$formatRupiah = formatRupiah
  }
}